<!--The content below is only a placeholder and can be replaced.-->
<div style="text-align:center">
  <h1 i18n="site header|Header for this site@@siteHeader">
    Shutter Simulator
  </h1>  
</div>

<div class="container mt-2">
  <!-- header -->
  <div class="row mb-3 border-bottom">
      <div class="col-2 text-center">
        <h5 i18n="@@allOther">All Other manufacturers</h5>
      </div>
      <div class="col-8 text-center">
        <p i18n="@@corrections">Corrections</p>
      </div>
      <div class="col-2 text-center">
        <h5>Ipas</h5>
      </div>
  </div>

  <!-- Different travel option row -->
  <div class="row border-bottom mb-3">
    <div class="col-2 text-center" style="color: green">
      <p><i class="fas fa-check"></i></p>
    </div>
    <div class="col-2 text-center">
        <input id="timeCheckbox" type="checkbox" checked (click)="this.changeCheckboxDiffTime($event,selectDesired.value)">
        <label for="timeCheckbox"></label>
    </div>
    <div class="col-4 text-center align-middle">        
        <span class="text-correction" i18n="@@differentTravel">Different travel time for up/down movement</span>
    </div>
    <div class="col-2 text-center">
        <img class="ets5" src="assets/ets5.png">
    </div>
    <div class="col-2 text-center" style="color: green">
        <p><i class="fas fa-check"></i></p>
    </div>
  </div>

  <!-- Curve correction option row -->
  <div class="row border-bottom mb-3">
      <div class="col-2 text-center" style="color: red">
        <p><i class="fas fa-times"></i></p>
      </div>
      <div class="col-2 text-center">
          <input id="curveCheckbox" type="checkbox" checked (click)="this.changeCheckboxCurve($event,selectDesired.value)">
          <label for="curveCheckbox"></label>
      </div>
      <div class="col-4 text-center">                  
        <span class="text-correction" i18n="@@curveCorrection">Curve correction</span>
      </div>
      <div class="col-2 text-center">
          <img class="ets5" src="assets/ets5.png">
      </div>
      <div class="col-2 text-center" style="color: green">
          <p><i class="fas fa-check"></i></p>
      </div>
    </div>

    <!-- Slit option row -->
  <div class="row border-bottom mb-3">
      <div class="col-2 text-center" style="color: red">
        <p><i class="fas fa-times"></i></p>
      </div>
      <div class="col-2 text-center">
          <input id="slitCheckbox" type="checkbox" checked (click)="this.changeCheckboxSlit($event,selectDesired.value)">
          <label for="slitCheckbox"></label>
      </div>
      <div class="col-4 text-center">                  
        <span class="text-correction" i18n="@@slitCorrection">Slit correction</span>
      </div>
      <div class="col-2 text-center">
          <img class="ets5" src="assets/ets5.png">
      </div>
      <div class="col-2 text-center" style="color: green">
          <p><i class="fas fa-check"></i></p>
      </div>
    </div>

    <!-- Actions -->
    <!--<div class="row">
        <div class="col text-center">
          <p i18n="@@realPosition">Real position</p>
        </div>
        <div class="col text-center">
          <p i18n="@@desiredPosition">Desired position</p>
        </div>
        <div class="col text-center">
          <p i18n="@@realPosition"> Real position</p>
        </div>
      </div>-->
      <div class="row border-bottom pb-3 mb-3">
        <div class="col-2 text-center">
            <i class="fas fa-times" *ngIf="shutter0Component.position !== this.position && this.shutter0Stopped" style="color:red"></i>
            <i class="fas fa-check" *ngIf="shutter0Component.position === this.position && this.shutter0Stopped" style="color:green"></i>        
        </div>
        <div class="col-2 text-center">                        
          <span class="mr-2"> {{shutter0Component.position}} % </span>                    
        </div>      
        <div class="col-3 text-center">                        
            <label for="selectDesired" i18n="@@blindPosition">Blind position</label>
            <select #selectDesired id="selectDesired" class="form-control-plaintext position" (change)="this.changeSelectPosition($event.target.value)">
              <option value="0">0 %</option>
              <option value="50">50 %</option>
              <option value="75">75 %</option>
              <option value="100">100 %</option>
            </select>   
            
        </div>      
        <div class="col-1 text-left">
          <span class="btn-send" (click)="this.btnSendClick(selectDesired.value)"><i class="fas fa-play-circle fa-2x"></i></span>
        </div>
        <div class="col-2 text-center">          
            <span class="mr-2">{{shutter1Component.position}} % </span>            
        </div>    
        <div class="col-2 text-center">
            <i class="fas fa-times" *ngIf="+shutter1Component.position !== +this.position && this.shutter1Stopped" style="color:red"></i>
            <i class="fas fa-check" *ngIf="+shutter1Component.position === +this.position && this.shutter1Stopped" style="color:green"></i>
        </div>                       
      </div>
  
      <div class="row mb-5">
        <div class="col-2 text-center">
            <i class="fas fa-times" *ngIf="+shutter0Component.positionSlit !== +this.positionSlit && this.shutter0Stopped || !this.shutter0.slitCorrection" style="color:red"></i>
            <i class="fas fa-check" *ngIf="+shutter0Component.positionSlit === +this.positionSlit && this.shutter0Stopped && this.shutter0.slitCorrection" style="color:green"></i>         
        </div>
        <div class="col-2 text-center">                  
            <span class="mr-2" i18n="@@notPossible">Not possible</span>             
        </div>      
        <div class="col-3 text-center"> 
          <label for="selectSlitDesired" i18n="@@slitPosition">Slit position</label>                       
          <select  #selectSlitDesired id="selectSlitDesired" class="form-control-plaintext position" (change)="changeSelectSlitPosition($event.target.value)">
            <option value="0">0 %</option>
            <option value="50">50 %</option>
            <option value="75">75 %</option>
            <option value="100">100 %</option>
          </select>          
        </div>           
        <div class="col-1 text-left">
            <span class="btn-send" (click)="this.btnSendSlitClick(selectSlitDesired.value)"><i class="fas fa-play-circle fa-2x"></i></span>
        </div> 
        <div class="col-2 text-center">
          <!--<span *ngIf="!this.shutterIpas.slitCorrection" class="mr-2" i18n="@@notPossible">Not possible</span> -->
          <span *ngIf="this.shutterIpas.slitCorrection" class="mr-2">{{shutter1Component.positionSlit}} % </span>                  
        </div>     
        <div class="col-2 text-center">
            <i class="fas fa-times" *ngIf="+shutter1Component.positionSlit !== +this.positionSlit && this.shutter1Stopped || !this.shutterIpas.slitCorrection" style="color:red"></i>
            <i class="fas fa-check" *ngIf="+shutter1Component.positionSlit === +this.positionSlit && this.shutter1Stopped && this.shutterIpas.slitCorrection" style="color:green"></i>                     
        </div>
      </div>  


    <!-- Shutters -->
    <div class="row mb-5">
      <div class="col-6 shutter0">
          <div class="shutter-bg"></div>
          <app-shutter #shutter0 [shutter]="this.shutterOther" (stopped)="this.stoppedShutter0()"></app-shutter>
      </div>
      <div class="col-6 shutter1">  
          <div class="float-right">
            <div class="shutter-bg"></div>
            <app-shutter #shutter1 [shutter]="this.shutterIpas" (stopped)="this.stoppedShutter1()"></app-shutter>
          </div>        
       </div>
    </div>

      
</div>

